<page-loader *ngIf="!isLoaded"></page-loader>
<div class="app-l-page-wrap" *ngIf="isLoaded">
    <div class="app-l-user-details">
        <div class="app-l-user-details_date">
            <span aria-label="Current date">{{ date | date: 'MMM d, y, EEE' }}</span>
            <div class="icon" aria-label="Notifications" title="Notifications">
                <svg-icon
                    icon="notificationIcon"
                    aria-hidden="true"></svg-icon>
            </div>
        </div>
    </div>
    <div class="app-l-page__navigation">
        <div
            class="app-l-page__previous"
            [routerLink]="['/professional/users']">
            <button
                class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                aria-label="Go back to user list">
                <svg-icon icon="arrow-left" class="w-100 h-100" aria-hidden="true"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <nav aria-label="Breadcrumb">
                <ul>
                    <li>
                        <a [routerLink]="['/professional/users']" translate
                            >menu.clientList</a
                        >
                    </li>
                    <li class="app-l-current-page" [attr.aria-current]="'page'" translate>
                        {{ user?.fullName }}
                    </li>
                </ul>
            </nav>
        </div>
    </div>
    <div class="app-c-card app-l-action-plan-preview-body app-l-user-details__card">
        <div class="app-l-room__pos">
            <div class="app-l-room__tabs">
                <my-tabs
                    role="tablist"
                    #tabGroup
                    (tabChange)="onTabChanged($event)"
                    [attr.aria-label]="'User details navigation tabs'">
                    <my-tab [tabTitle]="'OverView'" role="tab" [attr.aria-selected]="selectedTabIndex === 0" [attr.aria-controls]="'overview-panel'">
                        <ng-template #myTabTitle><span id="overview-tab">Overview</span></ng-template>
                        <div role="tabpanel" id="overview-panel" [attr.aria-labelledby]="'overview-tab'">
                            <app-user-details-overview
                                #userDetailsOverviewComp
                                *ngIf="user && userDetailOverview"
                                [countData]="countData"
                                [demographicData]="demographicDetail"
                                [userActionPlans]="userActionPlans"
                                [userDetail]="user"></app-user-details-overview>
                        </div>
                    </my-tab>
                    <my-tab [tabTitle]="'Assessment'" role="tab" [attr.aria-selected]="selectedTabIndex === 1" [attr.aria-controls]="'assessment-panel'">
                        <ng-template #myTabTitle>
                            <span id="assessment-tab">Assessment</span>
                        </ng-template>
                        <div role="tabpanel" id="assessment-panel" [attr.aria-labelledby]="'assessment-tab'">
                            <app-assessment-view
                                #userDetailsAssessmentComp
                                *ngIf="user && assessmentView"
                                [countData]="countData"
                                [demographicData]="demographicDetail"
                                [userDetail]="user"></app-assessment-view>
                        </div>
                    </my-tab>
                    <my-tab [tabTitle]="'Moodcheck'" role="tab" [attr.aria-selected]="selectedTabIndex === 2" [attr.aria-controls]="'moodcheck-panel'">
                        <ng-template #myTabTitle>
                            <span id="moodcheck-tab">Moodcheck</span>
                        </ng-template>
                        <div role="tabpanel" id="moodcheck-panel" [attr.aria-labelledby]="'moodcheck-tab'">
                            <app-moodcheck-view
                                #userDetailsMoodcheckComp
                                *ngIf="user && moodcheckView"
                                [countData]="countData"
                                [demographicData]="demographicDetail"
                                [userDetail]="user"></app-moodcheck-view>
                        </div>
                    </my-tab>
                    <my-tab [tabTitle]="'Series'" role="tab" [attr.aria-selected]="selectedTabIndex === 3" [attr.aria-controls]="'series-panel'">
                        <ng-template #myTabTitle>
                            <span id="series-tab">Series</span>
                        </ng-template>
                        <div role="tabpanel" id="series-panel" [attr.aria-labelledby]="'series-tab'">
                            <app-user-details-series
                                #userDetailsSeriesComp
                                *ngIf="user && seriesView"
                                [countData]="countData"
                                [demographicData]="demographicDetail"
                                [userDetail]="user"></app-user-details-series>
                        </div>
                    </my-tab>
                    <my-tab [tabTitle]="'Actionplan'" role="tab" [attr.aria-selected]="selectedTabIndex === 4" [attr.aria-controls]="'actionplan-panel'">
                        <ng-template #myTabTitle>
                            <span id="actionplan-tab">Action Plan</span>
                        </ng-template>
                        <div role="tabpanel" id="actionplan-panel" [attr.aria-labelledby]="'actionplan-tab'">
                            <app-action-plan-view
                                #userDetailsActionPlanComp
                                *ngIf="user && actionplanView"
                                [countData]="countData"
                                [demographicData]="demographicDetail"
                                [userActionPlans]="userActionPlans"
                                [userDetail]="user"></app-action-plan-view>
                        </div>
                    </my-tab>
                    <my-tab [tabTitle]="'Tools'" role="tab" [attr.aria-selected]="selectedTabIndex === 5" [attr.aria-controls]="'tools-panel'">
                        <ng-template #myTabTitle>
                            <span id="tools-tab">Tools</span>
                        </ng-template>
                        <div role="tabpanel" id="tools-panel" [attr.aria-labelledby]="'tools-tab'">
                            <app-tools-view
                                #userDetailsToolsComp
                                *ngIf="user && toolsView"
                                [countData]="countData"
                                [demographicData]="demographicDetail"
                                [userDetail]="user"></app-tools-view>
                        </div>
                    </my-tab>
                    <my-tab [tabTitle]="'OrgOwnContent'"  *ngIf="enableOrganizationOwnContents" role="tab" [attr.aria-selected]="selectedTabIndex === 6" [attr.aria-controls]="'orgcontent-panel'">
                        <ng-template #myTabTitle>
                            <span id="orgcontent-tab">Organization's Own Content</span>
                        </ng-template>
                        <div role="tabpanel" id="orgcontent-panel" [attr.aria-labelledby]="'orgcontent-tab'">
                            <app-user-org-own-content
                                #userDetailsSeriesComp
                                *ngIf="user && orgContentView"
                                [countData]="countData"
                                [demographicData]="demographicDetail"
                                [userDetail]="user"></app-user-org-own-content>
                        </div>
                    </my-tab>
                </my-tabs>
            </div>
            <!-- <div *ngIf="filteredItems.length <= 0">
                    <div class="empty-card">
                        <div class="app-dm-positive-cards"
                            [translate]="!this.isLoading ? 'actionPlan.noDataFound' : ''">
                        </div>
                    </div>
                </div> -->
        </div>
    </div>
</div>
